<div id="g-suite-login-button" />

<script>
    import { onMount } from 'svelte';
    import { store } from '../store';
    import { onSignIn } from './../api';

    onMount(() => {
        google.accounts.id.initialize({
            client_id: $store.clientId,
            callback: onSignIn,
            auto_select: true,
            cancel_on_tap_outside: false,
        });
        google.accounts.id.renderButton(
            document.getElementById("g-suite-login-button"),
            { theme: "outline", size: "large" }
        );
        google.accounts.id.prompt();
    });
</script>
